import { useState } from 'react';
import { useTheme } from '../context/ThemeContext';

let _logoId = 0;

export function Logo({ size = 36 }) {
  const { dark } = useTheme();
  const [id] = useState(() => ++_logoId);
  const gId = 'lg' + id;
  const glId = 'gl' + id;

  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
      <defs>
        <linearGradient id={gId} x1="0" y1="0" x2="100" y2="100">
          <stop offset="0%" stopColor="#f59e0b" />
          <stop offset="100%" stopColor="#ea580c" />
        </linearGradient>
        <linearGradient id={glId} x1="20" y1="20" x2="60" y2="60">
          <stop offset="0%" stopColor={dark ? '#1e293b' : '#e0f2fe'} />
          <stop offset="100%" stopColor={dark ? '#0f172a' : '#bae6fd'} />
        </linearGradient>
      </defs>
      <rect x="62" y="62" width="14" height="36" rx="7" transform="rotate(-45 62 62)" fill={'url(#' + gId + ')'} />
      <circle cx="40" cy="40" r="32" stroke={'url(#' + gId + ')'} strokeWidth="8" fill="none" />
      <circle cx="40" cy="40" r="26" fill={'url(#' + glId + ')'} />
      <path d="M40 24 L27 35 L27 50 L34 50 L34 42 L46 42 L46 50 L53 50 L53 35 Z" fill={'url(#' + gId + ')'} opacity=".85" />
      <ellipse cx="30" cy="30" rx="6" ry="4" transform="rotate(-30 30 30)" fill="#fff" opacity=".35" />
    </svg>
  );
}

export function Brand({ size = 'md' }) {
  const s = size === 'sm' ? 20 : size === 'lg' ? 42 : 28;
  const fs = size === 'sm' ? '14px' : size === 'lg' ? '22px' : '17px';
  const lh = size === 'sm' ? 1 : 1.05;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
      <Logo size={s} />
      <span className="display" style={{ fontSize: fs, fontWeight: 600, letterSpacing: '-.4px', lineHeight: lh }}>
        <span style={{ color: 'var(--br)' }}>Lupa</span>
        <span style={{ color: 'var(--tx)' }}>Leilão</span>
      </span>
    </div>
  );
}
